
export function getHost (subname) {
  let host = window.location.host
  let protocol = window.location.protocol
  let temp = host.split('.')
  // 兼容多种host形式， eg: www.craitapp.com / craitapp.com
  if (temp.length === 2) {
    temp.unshift(subname)
  } else if (temp.length === 3) {
    temp.splice(0, 1, subname)
  }
  let newHost = temp.join('.')
  return protocol + '//' + newHost
}



// WEBPACK FOOTER //
// ./src/utils.js